<template>
	<svg
		class="ov-busy-spinner"
		viewBox="0 0 38 38"
		xmlns="http://www.w3.org/2000/svg"
		:width="size"
		:height="size"
	>
		<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
			<g transform="translate(1 1)">
				<circle stroke-opacity=".25" cx="18" cy="18" r="18" />
				<path d="M36 18c0-9.94-8.06-18-18-18">
					<animateTransform
						attributeName="transform"
						type="rotate"
						from="0 18 18"
						to="360 18 18"
						dur="0.8s"
						repeatCount="indefinite"
					/>
				</path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: "OvBusySpinner",
	props: {
		size: { type: Number, default: 64 },
	},
};
</script>

<style lang="scss" scoped>
.ov-busy-spinner {
	display: block;
	flex-shrink: 0;
	color: var(--ds-color-primary);
}
</style>
